import React from "react";
import { AdminProducerListSummaryPreviewTemplate } from "themes/administration/producer/components";

function AdminProducerListSummaryPreview(props) {
    return <AdminProducerListSummaryPreviewTemplate {...props} />;
}

export default AdminProducerListSummaryPreview;
